import { render, staticRenderFns } from "./print-size.vue?vue&type=template&id=41a51d2c&scoped=true"
import script from "./print-size.vue?vue&type=script&lang=js"
export * from "./print-size.vue?vue&type=script&lang=js"
import style0 from "./print-size.vue?vue&type=style&index=0&id=41a51d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a51d2c",
  null
  
)

export default component.exports